<div>
    <canvas id="pdfCanvas"></canvas>
</div>
